import React, { createContext, FC, ReactNode, useMemo } from 'react';

import { getPredefinedFeatures } from '../common/utils/feature';

interface FeatureFlagsContextProps {
	features: Record<string, any>;
}

export const FeatureFlags = createContext<FeatureFlagsContextProps | undefined>(
	undefined,
);

interface FeatureFlagsProviderProps {
	children: ReactNode;
}

const FeatureFlagsProvider: FC<FeatureFlagsProviderProps> = ({ children }) => {
	const predefinedFeatures = getPredefinedFeatures();

	const value = useMemo(
		() => ({ features: predefinedFeatures }),
		[predefinedFeatures],
	);

	return (
		<FeatureFlags.Provider value={value}>{children}</FeatureFlags.Provider>
	);
};

export default FeatureFlagsProvider;
